import { AuthStore } from 'store/auth/types.ts'
import { InternalUserRole } from '@boltenergy-be/shared'

export const initialAuthState: AuthStore = {
  email: '',
  error: null,
  loading: false,
  role: '' as InternalUserRole
}
